'use client';

import { forwardRef, type FunctionComponent } from 'react';
import Link from 'next/link';
import {
  PolymorphicComponentProps,
  UnstyledButton,
  UnstyledButtonProps,
} from '@mantine/core';

type UnstyledLinkButtonProps = Omit<
  PolymorphicComponentProps<typeof Link, UnstyledButtonProps>,
  'component'
>;

/**
 * UnstyledLinkButton
 *
 * An UnstyledButton with Link characteristics.
 * This component allows use of UnstyledButton with next/link in next16, where changes to
 * Link caused polymorphic errors without 'use client' directives;
 */
const UnstyledLinkButton: FunctionComponent<UnstyledLinkButtonProps> =
  forwardRef<HTMLAnchorElement, UnstyledLinkButtonProps>((props, ref) => (
    <UnstyledButton component={Link} ref={ref} {...props} />
  ));

UnstyledLinkButton.displayName = 'UnstyledLinkButton';

export default UnstyledLinkButton;
